import { BankAccount, OperationType } from "@/interfaces/talk2pay.iterfaces";
import { SelectData } from "@/types/form.types";

export const ACCOUNT_TYPE_OPTIONS = () => [
  { value: OperationType.TED, label: OperationType.TED },
  { value: OperationType.PIX, label: OperationType.PIX },
];

export const BANKS_OPTIONS = (banks?: BankAccount[]): SelectData<string>[] => {
  if (!banks) return [];
  return banks.map((bank) => ({
    value: bank.id,
    label: bank.name,
  }));
};
